import { render } from "./transfer_bank_account_body.vue?vue&type=template&id=b5a01c0c"
import script from "./transfer_bank_account_body.vue?vue&type=script&lang=js"
export * from "./transfer_bank_account_body.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__